module.exports = __webpack_public_path__ + "static/img/zp.e952ada.png";


//////////////////
// WEBPACK FOOTER
// ./static/about/zp.png
// module id = CiCg
// module chunks = 1